var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-/-Inline-/-Warning",
    transform: "translate(-16.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Illustrative-/-Exclamation-Mark",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "#FFCD00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9731677,16.4990311 C11.1518012,16.4990311 10.4839752,17.1652174 10.4839752,17.9865839 C10.4839752,18.8079503 11.1518012,19.4744348 11.9731677,19.4744348 C12.7930435,19.4744348 13.4608696,18.8079503 13.4608696,17.9865839 C13.4608696,17.1652174 12.7930435,16.4990311 11.9731677,16.4990311 Z M11.9731677,0.126708075 C5.39776398,0.126708075 0.0670807453,5.4573913 0.0670807453,12.032795 C0.0670807453,18.6096894 5.39776398,23.9403727 11.9731677,23.9403727 C18.5485714,23.9403727 23.8792547,18.6096894 23.8792547,12.032795 C23.8792547,5.4573913 18.5485714,0.126708075 11.9731677,0.126708075 Z M11.9731677,1.11965217 C17.9910559,1.11965217 22.8864596,6.01490683 22.8864596,12.032795 C22.8864596,18.0506832 17.9910559,22.9475776 11.9731677,22.9475776 C5.9552795,22.9475776 1.05838509,18.0506832 1.05838509,12.032795 C1.05838509,6.01490683 5.9552795,1.11965217 11.9731677,1.11965217 Z M11.9731677,18.4829814 C11.698882,18.4829814 11.4767702,18.2608696 11.4767702,17.9865839 C11.4767702,17.7122981 11.698882,17.4901863 11.9731677,17.4901863 C12.2459627,17.4901863 12.4695652,17.7122981 12.4695652,17.9865839 C12.4695652,18.2608696 12.2459627,18.4829814 11.9731677,18.4829814 Z M10.9803727,15.506087 L11.0057143,15.506087 L12.9406211,15.506087 L12.964472,15.506087 L12.9659627,15.506087 C13.228323,15.506087 13.4474534,15.3003727 13.4608696,15.0350311 L13.9557764,5.11304348 C13.9706832,4.83875776 13.7590062,4.60621118 13.4862112,4.59279503 L13.4608696,4.59279503 L10.4839752,4.59279503 L10.4601242,4.59279503 C10.1858385,4.60621118 9.97565217,4.83875776 9.98906832,5.11304348 L10.4854658,15.0350311 C10.498882,15.3003727 10.7180124,15.506087 10.9803727,15.506087 Z M12.9391304,5.58409938 L12.4934161,14.5132919 L11.4529193,14.5132919 L11.0057143,5.58409938 L12.9391304,5.58409938 Z",
    id: "icon_721"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7cdd8c2b481bc361271a4761521bac83.svg";
export { ForwardRef as ReactComponent };